module.exports = __webpack_public_path__ + "static/img/01.33236a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/01.png
// module id = ccZq
// module chunks = 0